import { createAsyncThunk } from '@reduxjs/toolkit';

export const qrAccountCreate = createAsyncThunk(
    'users/create/qracc',
    async (_, thunkAPI,) => {

        try {
            const res = await fetch(`/api/users/create/qracc`, {
                method: 'POST',
                headers: {
                    Accept: 'application/JSON',
                    'Content-Type': 'application/json'
                },
            });

            const data = await res.json();

            if (res.status === 201) {
                return data;

            } else {
                console.log("qrAccountCreate != 201 -----------------------");
                return thunkAPI.rejectWithValue(data);
            }

        } catch (err) {
            console.log("qrAccountCreate Error -----------------------");
            console.log(err);
            return thunkAPI.rejectWithValue(err.response.data);
        }
    }
);